
import { Component, Prop, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";

import  ButtonVue from "@/lib/Button.vue";
import { Next, Route } from 'vue-router';
import { ITree } from "@/tree/ITree";
import { IFin} from "./IFin"
import { Fin} from "./Fin"
import { FinSvc } from "./FinSvc"
import NakladyVue from "./NakladyVue.vue";

import Bus from "@/lib/Bus"; import Naklady from "./NakladyVue.vue";
import { IMasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { TreeSvc } from "@/tree/TreeSvc";
import { IWykrojnik } from "@/wykrojniki/IWykrojnik";
import { WykrojnikRow } from "@/wykrojniki/WykrojnikRow";
 const bus: Bus = new Bus().getBus();


 @Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<FinVue>) {
   
            console.log(to.params.id)
            
            let fin = <IFin|undefined> await new FinSvc().find_by_id(  to.params.id ).catch((err)=>console.log(err));
           
            next((vm: FinVue) => {
               vm.fin = fin;
               vm.tree_id = to.params.id
            });
    
        },

      components: { FinderVue, ButtonVue, NakladyVue, Naklady }
})
export default class FinVue extends Vue {
    
    fin:IFin|undefined;
    key:number=0;
    currencies:string[] = ["PLN", "EUR"]
    deliveries:string[] = ["Ex Works (EXW)","Delivered Duty Paid (DDP)","Delivered At Place (DAP)"]
    expires:number[] = [10,20,30,40,50,60]
    tree_id:any;
    masterData:IMasterData|undefined

    created() {
    }


    async mounted() {
      this.masterData = await (await new Store().getStore()).masterData;
     
      if (this.fin) {
        this.countWykrojnikCost(this.fin)
        this.countPolymerCost(this.fin)
      }
      this.key++
    }


    beforeDestroy() {
    }

    async naklady_changed() {
      await this.chg()
    }

    async useWyliczoneDlaWykr(pln:number) {
      if (!this.fin) return;
      this.countWykrojnikCost(this.fin)
      this.fin.kosztWykrojnikaPLN = this.fin.kosztWykrojnikaWyliczonyPLN      
      this.fin.kosztWykrojnikaEUR = this.fin.kosztWykrojnikaWyliczonyEUR      
      this.fin.koszt_wykrojnika_w_PLN = pln
      this.chg()     
      this.key++
    }

    async useWyliczoneDlaPolimeru(pln:number) {
      if (!this.fin) return;
      this.countPolymerCost(this.fin)
      this.fin.kosztPolimeruPLN = this.fin.kosztPolimeruWyliczonyPLN      
      this.fin.kosztPolimeruEUR = this.fin.kosztPolimeruWyliczonyEUR      
      this.fin.koszt_polimeru_w_PLN = pln
      this.chg()
      this.key++
    }


    async countWykrojnikCost(fin:IFin) {
        const wykrojnik:IWykrojnik | undefined = await new TreeSvc().get_selected_wykrojnik_for_tree(this.tree_id);
        if (!wykrojnik) return;
        fin.kosztWykrojnikaWyliczonyEUR = WykrojnikRow.getKosztBlachyWykrojnikaEUR(wykrojnik);
        if (fin.kosztWykrojnikaWyliczonyEUR<fin.kosztWykrojnikaMinEUR) fin.kosztWykrojnikaWyliczonyEUR=fin.kosztWykrojnikaMinEUR

        fin.kosztWykrojnikaWyliczonyPLN = parseInt((fin.kosztWykrojnikaWyliczonyEUR * fin.kurs_euro).toString());
        if (fin.kosztWykrojnikaWyliczonyPLN<fin.kosztWykrojnikaMinPLN) fin.kosztWykrojnikaWyliczonyPLN=fin.kosztWykrojnikaMinPLN
        this.key++
    }
  
    async countPolymerCost(fin:IFin) {
        const wykrojnik:IWykrojnik | undefined = await new TreeSvc().get_selected_wykrojnik_for_tree(this.tree_id);
        console.log('wykrojnik',wykrojnik)
        if (!wykrojnik) return;
        fin.kosztPolimeruWyliczonyPLN = WykrojnikRow.getKosztPolimeruPLN(wykrojnik);
        if (fin.kosztPolimeruWyliczonyPLN<fin.kosztPolimeruMinPLN) fin.kosztPolimeruWyliczonyPLN=fin.kosztPolimeruMinPLN

        fin.kosztPolimeruWyliczonyEUR = parseInt((fin.kosztPolimeruWyliczonyPLN/fin.kurs_euro).toString());
        if (fin.kosztPolimeruWyliczonyEUR<fin.kosztPolimeruMinEUR) fin.kosztPolimeruWyliczonyEUR=fin.kosztPolimeruMinEUR
        this.key++
    }

    async chg_wykr(pln:number) {
      if (!this.fin) return;
      this.fin.koszt_wykrojnika_w_PLN = pln
      await this.chg()
    }

    async chg_poly(pln:number) {
      if (!this.fin) return;
      this.fin.koszt_polimeru_w_PLN = pln
      await this.chg()
    }

    async chg() {
      if (!this.fin) return;

      let ret:IFin|undefined=undefined;
      ret = await new FinSvc().save( this.fin )
      if (ret) {
        this.fin.version = ret.version;
        this.fin._id= ret._id;
      } 
    }

}

